import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';

export function ShareLoadingCard() {
  useLanguage();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="w-full bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.08)] overflow-hidden"
    >
      {/* Header skeleton */}
      <div className="p-6 sm:p-7 pb-5">
        <div className="flex justify-center mb-5">
          <Skeleton className="w-14 h-14 rounded-xl" />
        </div>
        <Skeleton className="h-7 w-3/4 mx-auto mb-3" />
        <Skeleton className="h-4 w-2/3 mx-auto" />
      </div>

      {/* Info Card skeleton */}
      <div className="px-6 sm:px-7">
        <div className="bg-slate-50 rounded-xl p-4 space-y-3">
          <div className="flex items-center gap-3">
            <Skeleton className="w-4 h-4 rounded" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-32" />
          </div>
          <div className="flex items-center gap-3">
            <Skeleton className="w-4 h-4 rounded" />
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-40" />
          </div>
          <div className="flex items-center gap-3">
            <Skeleton className="w-4 h-4 rounded" />
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-44" />
          </div>
        </div>
      </div>

      {/* Rules skeleton */}
      <div className="px-6 sm:px-7 py-5">
        <Skeleton className="h-4 w-24 mb-3" />
        <div className="space-y-2.5">
          <div className="flex items-start gap-3">
            <Skeleton className="w-4 h-4 rounded mt-0.5" />
            <Skeleton className="h-4 w-full" />
          </div>
          <div className="flex items-start gap-3">
            <Skeleton className="w-4 h-4 rounded mt-0.5" />
            <Skeleton className="h-4 w-5/6" />
          </div>
          <div className="flex items-start gap-3">
            <Skeleton className="w-4 h-4 rounded mt-0.5" />
            <Skeleton className="h-4 w-4/5" />
          </div>
        </div>
      </div>

      {/* Checkbox + Buttons skeleton */}
      <div className="px-6 sm:px-7 pb-6 sm:pb-7 space-y-4">
        <div className="flex items-start gap-3">
          <Skeleton className="w-4 h-4 rounded mt-0.5" />
          <div className="flex-1">
            <Skeleton className="h-4 w-48 mb-1" />
            <Skeleton className="h-3 w-56" />
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2.5">
          <Skeleton className="h-12 flex-1 rounded-md" />
          <Skeleton className="h-12 w-24 rounded-md" />
        </div>
      </div>

      {/* Loading text */}
      <div className="absolute inset-0 flex items-center justify-center bg-white/50 backdrop-blur-[1px]">
        <p className="text-sm text-muted-foreground animate-pulse">
          {translateInterfaceText("Carregando detalhes do compartilhamento…")}</p>
      </div>
    </motion.div>
  );
}
